import { render, staticRenderFns } from "./UiIcons.vue?vue&type=template&id=7690a9e8&lang=pug&"
import script from "./UiIcons.vue?vue&type=script&lang=ts&"
export * from "./UiIcons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports